var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.12@core-js/modules/_html.js
// module id = 135
// module chunks = 64